import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { DashboardService } from "../../services/DashboardService";
import { Pagination } from "../../Interfaces/Interfaces";


export const getAgentDashboard = () => {
  const api = new DashboardService().getAgentDashboard();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_DASHBOARD",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "AGENT_DASHBOARD",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getAgentActivityChartAction = (data: any) => {
  const api = new DashboardService().getAgentActivityDashboardServices(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_DASHBOARD_ACTIVITY_CHART",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "AGENT_DASHBOARD_ACTIVITY_CHART",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAchievementAction = (data: any) => {
  const api = new DashboardService().getAchievementDashboardServices(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ACHIEVEMENT_DATA",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "ACHIEVEMENT_DATA",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAggregatorCountDashboard = (data: any) => {
  const api = new DashboardService().AggregatorCountDashboardService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGGREGATOR_COUNT",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getEarningDashboard = (data: any) => {
  const api = new DashboardService().getEarningDashboard(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "EARNING_DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAgentComissionEarningDashboard = (data: any) => {
  const api = new DashboardService().getAgentComissionEarningDashboard(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_COMMISSION_EARNING_DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getAggregatorComissionEarningDashboard = (data: any) => {
  const api = new DashboardService().getAggregatorEarningDashboard(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_COMMISSION_EARNING_DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getTransactionTergetByAgent = (
  agentId: any,
  whereCondition: any
) => {
  const api = new DashboardService().getTransactionAgentByIdService(
    agentId,
    whereCondition
  );

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGENT_TARGETBYID",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "GET_AGENT_TARGETBYID",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getCustomersByAgent = (agentId: any, whereCondition: any) => {
  const api = new DashboardService().getCustomersAgentByIdService(
    agentId,
    whereCondition
  );

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGENT_CUSTOMERSBYID",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getTransactionByAgent = (agentId: any, whereCondition: any) => {
  const api = new DashboardService().getTransactionsAgentByIdService(
    agentId,
    whereCondition
  );

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGENT_TRANSACTIONBYID",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getTransactionDashboard = (data: any) => {
  const api = new DashboardService().getTransactionDashboard(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_DASHBOARD",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "TRANSACTION_DASHBOARD",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getTransactionCountDashboardSummaryAction = () => {
  const api = new DashboardService().getTransactionCountDashboardSummray();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_DASHBOARD_COUNT",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "TRANSACTION_DASHBOARD_COUNT",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getPerFormanceMetricsAndComissionAction = (data: any) => {
  const api = new DashboardService().getPerformanceMetricsAndCommissionService(
    data
  );

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_PERFORMANCE_AND_COMMISSION",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAgentPerformanceDashboardAction = (data: any) => {
  const api = new DashboardService().getAgentPerformanceDashboardService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGENT_PERFORMANCE_DASHBOARD",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getAggregatorPerformanceDashboardAction = (data: any) => {
  const api = new DashboardService().getAggregatorPerformanceDashboardService(
    data
  );

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_AGGREGATOR_PERFORMANCE_DASHBOARD",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getPosDashboardAction = () => {
  const api = new DashboardService().getPosMetricsDashboardService();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_POS_METRICS_DASHBOARD",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getFloatDashboardAction = () => {
  const api = new DashboardService().getFloatDashboardService();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_Float_METRICS_DASHBOARD",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getEarningComissionDashboardAction = (data: any) => {
  const api = new DashboardService().getEarningCommissionDashboardService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "GET_EARNING_COMMISSION_DASHBOARD",
            payload: res.result,
          });
        } else {
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};

export const getBottomAgentDashboardAction = (data: any) => {
  const api = new DashboardService().getBottomAgentService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "BOTTOM_AGENT_PERFORMANCE",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "BOTTOM_AGENT_PERFORMANCE",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "", //"Network request failed"",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getAnalyticalUpdateDashboardAction = () => {
  const api = new DashboardService().getAnalyticsDashboardService();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD_ANALYTICS",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "DASHBOARD_ANALYTICS",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "",//"Network request failed"",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
export const getCoordinatorDashboard = () => {
  const api = new DashboardService().getcoordinatordashboard();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "TRANSACTION_DASHBOARD",
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "TRANSACTION_DASHBOARD",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "",//"Network request failed"",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false,
        });
      });
  };
};
